<template>
  <div>
    <div class="builder-page">
        <Header :heading="'Profile'"></Header>
      <div class="main-section">
        <Leftmenu></Leftmenu>
        <div class="right-section">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->

          <div class="content">
            <div class="form-section">
              <div class="profile-left">
                <div class="left-form">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>First Name<span class="required">*</span></label>
                      <input
                        class="form-control"
                        v-model="First_Name"
                        type="text"
                        @input="err_name = false"
                        v-on:keypress="validateKeyPress(event)"
                        name
                        placeholder="e.g. Rahul"
                      >
                    </div>
                    <span
                      v-if="err_name"
                      style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
                    >Enter valid first name</span>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Surname</label>
                      <input
                        class="form-control"
                        type="text"
                        v-on:keypress="validateKeyPress(event)"
                        v-model="Last_Name"
                        name
                        placeholder="e.g. Sharma"
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Profession</label>
                      <input
                        class="form-control"
                        type="text"
                        v-on:keypress="validateKeyPress(event)"
                        v-model="Profession"
                        name
                        placeholder="e.g. Software Engineer"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Pincode</label>
                      <input
                        class="form-control"
                        type="number"
                        v-on:keypress="isPincode(event)"
                        v-model="Pin_code"
                        @input="populatecitycountry"
                        name
                        placeholder="302006"
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Country</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="Country"
                        name
                        placeholder="India"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>City</label>
                      <!-- <input
                        class="form-control"
                        v-model="City"
                        type="text"
                        name
                        placeholder="Jaipur"
                      >-->
                      <multiselect
                        v-model="City"
                        :options="cities"
                        :taggable="true"
                        @tag="onTagcity($event)"
                        :multiple="false"
                      ></multiselect>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Phone</label>
                      <input
                        class="form-control"
                        type="number"
                        v-on:keypress="isNumber(event)"
                        v-model="Phone"
                        name
                        @input="err_phone = false"
                        placeholder="e.g. 9876543210"
                      >
                    </div>
                    <span
                      v-if="err_phone"
                      style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
                    >Enter valid phone number</span>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Email</label>
                      <input
                        class="form-control global-disabled"
                        type="email"
                        name
                        v-model="Email"
                        placeholder="e.g. sharma@gmail.com"
                      >
                    </div>
                  </div>
                </div>
              </div>
                <div style="justify-content:flex-end;" class="btn-sec">
                  <a href="javascript:void(0);" @click.prevent="updateuser" class="btn-primary md-ink-ripple">Save</a>
                </div>
              </div>
              
              <div class="right-form">
                <div class="upload-img">
                  <div v-if="temp_pic!=''" class="img-box">
                    <img id="imgPreview" :src="temp_pic" alt>
                  </div>
                  <div v-else class="img-box">
                    <img id="imgPreview" src="data:image/png;base64,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" alt>
                  </div>
                  <label class="file-upload-box" for="fileUpload">
                    <img src="../../assets/upload-icon.png" alt=""/>
                    <span> <span>Upload</span> your Photo</span>
                  </label>
                  <input
                    style="display: none;"
                    type="file"
                    name="fileUpload"
                    @change="previewFiles"
                    id="fileUpload"
                    accept="image/*"
                  >
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>

      <!-- Optional JavaScript -->
      <!-- jQuery first, then Popper.js, then Bootstrap JS -->
    </div>
    <transition name="fade">
    <Messages
      v-if="isdisplaymsg"
      :datamessage="sucessmsgtext"
      v-on:closemsg="closeMessage"
      v-bind:isVisible="isdisplaymsg"
    ></Messages>
    </transition>
    <div v-if="loader" class="template-loader-hiw hide">
    <div class="loader-overlay"></div>
    <div class="progress-bar-wrapper">
      <img
        src="../../assets/check-circle.svg"
        v-if="finished"
        alt="Check Circle"
        width="48"
        height="48"
        class="icon-check-circle hide"
      >
      <p class="progress-text step1">{{ loadermsg }}</p>
      <div v-if="!finished" class="progress-bar">
        <div class="progress-linear"></div>
        <div class="progress-gradient progress-animate"></div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import axios from "axios";
import Header from "@/components/Header.vue";
import Leftmenu from "@/components/Leftmenu.vue";
import rest_service from "@/api/rest_service_api.js";
import multiselect from "vue-multiselect";
import Messages from "@/components/MessagePopup/Messages";
export default {
  components: {
    Header,
    Leftmenu,
    multiselect,
    Messages
  },
  data() {
    return {
      loader: false,
      finished: false,
      loadermsg: "",
      isdisplaymsg: false,
      sucessmsgtext: "",
      temp_pic: "",
      First_Name: "",
      Last_Name: "",
      Profession: "",
      ext_Profession: "",
      City: "",
      Country: "",
      Pin_code: "",
      Phone: "",
      Email: "",
      Uniqueid:"",
      cities:[],
      err_phone:false,
      err_name:false
    };
  },
  created() {
      this.Getuser();
  },
  methods: {
    onTagcity(new_tag) {
      this.City = new_tag;
    },
    Getuser() {
      debugger;
      var self = this;
      var uid = JSON.parse(localStorage.getItem("loggedinuserobj"));
      axios({
        method: "get",
        url: rest_service.baseURL + "/User/GetUserbyemail",
       //url: "https://localhost:7101/api" + "/User/GetUserbyemail",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + uid.returnedToken,
        },
        params: {
          email: uid.user.email,
        },
      })
        .then(function (response) {
          if (response.data) {
            var profile = response.data.result;
            self.First_Name = profile.firstName != ""&& profile.firstName != null ? profile.firstName : "";
            self.Last_Name = profile.lastName != ""&& profile.lastName != null ? profile.lastName : "";
            self.Email = profile.email != ""&& profile.email != null ? profile.email : "";
            self.Pin_code = profile.pincode != ""&& profile.pincode != null ? profile.pincode : "";
            self.Profession = profile.profession != ""&& profile.profession != null ? profile.profession : "";
            self.Country = profile.country != ""&& profile.country != null ? profile.country : "";
            self.City = profile.city != ""&& profile.city != null ? profile.city : "";
            self.Phone = profile.phone != ""&& profile.phone != null ? profile.phone : "";
            self.Uniqueid = profile.uniqueId != ""&& profile.uniqueId != null ? profile.uniqueId : "";
            debugger;
            if (
        profile.profilePic != null &&
        profile.profilePic != ""
      ) {
        self.GetProfilrpic(profile.profilePic);
        // self.resumeobj.coverletterobject;
      }
          } else {
            return null;
          }
        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
    },
    validateprofile() {
      this.err_name = false;
      var check = false;
      if (this.First_Name == "") {
        this.err_name = true;
        check = true;
      }
      if(this.Phone!=""){
      if (this.Phone.length < 10) {
        this.err_phone = true;
        check = true;
      }
      }
      return check;
    },
    populatecitycountry() {
      var self = this;
      var urls =
        "https://maps.googleapis.com/maps/api/geocode/json?address=" +
        self.Pin_code +
        "&key=AIzaSyCI9dR-Xj_nDADm1U_3-v8dzOAJDzkgpRQ";
      axios({
        method: "get",
        // url: rest_service.PythonAPI + "/search",
        url: urls,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(function(response) {
          if (response.data) {
            const data = response.data;
            if (data.results.length > 0) {
              self.cities = data.results[0].postcode_localities;
              const addressComponents = data.results[0].address_components;
              self.City = addressComponents.find(component =>
                component.types.includes("locality")
              ).long_name;
              self.Country = addressComponents.find(component =>
                component.types.includes("country")
              ).long_name;
              // Use city and country data
            } else {
              self.City = "";
              self.Country = "";
            }
          } else {
            self.City = "";
            self.Country = "";
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    closeloader() {
      var self = this;
      self.loader = false;
      self.finished = false;
    },
    updateuser() {
      debugger;
      var self = this;
      if(!self.validateprofile()){
      self.loadermsg = "Saving....";
        self.loader = true;
        self.finished = false;
      let base64encoded = "";
      var updatedFile = $("#imgPreview").prop("src");
      if(updatedFile!=undefined){
          base64encoded = updatedFile.toString();
      const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
      base64encoded = base64encoded.substring(sIndex);
      }
        
      var data={
         firstName: self.First_Name,
         lastName:self.Last_Name,
         email: self.Email,
         pincode:self.Pin_code,
         profession:self.Profession,
         country:self.Country,
         city:self.City,
         phone:self.Phone,
         profilePic:base64encoded,
         uniqueId:self.Uniqueid
      };
      var uid = JSON.parse(localStorage.getItem("loggedinuserobj"));
      axios({
        method: "post",
        url: rest_service.baseURL + "/User/Updateuser",
      // url: "https://localhost:7101/api" + "/User/Updateuser",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + uid.returnedToken,
        },
        data:data
      })
        .then(function (response) {
          if (response.data) {
              if(localStorage.getItem("image")){
                 localStorage.removeItem("image"); 
              }
              if(localStorage.getItem("fullName")){
                 localStorage.removeItem("fullName"); 
              }

            self.loadermsg = "Saved successfully";
            self.finished = true;
            setTimeout(xy => {
              self.closeloader();
            }, 2000);
            setTimeout(y => {
              self.navigate();
            }, 1000);
          } else {
              self.loader = false;
            return null;
          }
        })
        .catch(function (error) {
            self.loader = false;
          console.log(error);
          return error;
        });
    }
    },
    navigate(){    
        this.$router.push({
              path: "/dashboard"
            });  
    },
    GetProfilrpic(id) {
      var self = this;
      var uid = JSON.parse(localStorage.getItem("loggedinuserobj"));
      axios({
        method: "get",
        url: rest_service.baseURL + "/S3proxy/GetAllImagebase64",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + uid.returnedToken,
        },
        responseType: "blob",
        params: {
          id: uid.user.email+"/"+id,
        },
      })
        .then(function (respo) {
          if (respo) {
            var reader = new FileReader();
            reader.onload = () => {
              const base64String = reader.result;
              console.log(base64String);
              // response.data.result.profilePic = base64String;
              self.temp_pic = base64String;
            };
            reader.readAsDataURL(respo.data);
          } else {
            return null;
          }
        })
        .catch(function (error) {
          console.log(error);
          return error;
        });
    },
    previewFiles(event) {
      debugger;
      this.isCorrupt = true;
      var self = this;
      var fileIn = event.target.files[0];
      const fileReader = new FileReader();

      fileReader.onload = () => {
        const image = new Image();

        image.onerror = () => {
          // Image failed to load or is corrupted
          console.log("The selected image is corrupted.");
          self.isCorrupt = false;
          $("#fileUpload").val("");
          return prevent();
          //alert("corrupted");
        };

        image.onload = () => {
          // Image loaded successfully
          console.log("The selected image is valid.");
        };

        image.src = fileReader.result;
      };

      fileReader.readAsDataURL(fileIn);
      self.validateFile();
      if (self.isCorrupt) {
        var file = event.target.files[0];
        if (file) {
          let reader = new FileReader();
          reader.onload = function(event) {
            $("#imgPreview").attr("src", event.target.result);
          };
          reader.readAsDataURL(file);
        }
      }
    },
    validateFile() {
      var fileName = document.getElementById("fileUpload").value;
      var dot = fileName.lastIndexOf(".") + 1;
      var extFile = fileName.substr(dot, fileName.length).toLowerCase();
      var tempFiles1 = document.getElementById("fileUpload").files;
      if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(fileName)) {
        $("#fileUpload").val("");
        return prevent();
      }
      //alert(this.fileCount > this.$store.state.helper.allowedFileSize? "larger":"smaller");
    },
    validateKeyPress(event) {
      debugger;
      event = event ? event : window.event;
      // Get the keycode of the pressed key
      const keyCode = event.keyCode || event.which;

      // Allow letters (a-z and A-Z) and space (keycode 32)
      if (event.currentTarget._value.length >= 200) {
        event.preventDefault();
      } else if (
        (keyCode >= 65 && keyCode <= 90) || // Uppercase letters
        (keyCode >= 97 && keyCode <= 122) || // Lowercase letters
        keyCode === 32
      ) {
        return true; // Allow the key press
      } else {
        event.preventDefault(); // Prevent any other key presses
      }
    },
    isPincode: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else if (evt.currentTarget._value.length >= 6) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else if (evt.currentTarget._value.length >= 10) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.right-section .form-section {
    display: flex;
}

.right-section .form-section .profile-left {
  width:65%;

}
.right-section .form-section .left-form {
    background: #eef6f9;
    padding: 25px;
    border-radius: 10px;
    border: 1px solid #ddd;
}
.profile-left .btn-sec {
    display: flex;
    justify-content: flex-end;
    margin: 25px 0 0;
}
.right-section .form-section  .right-form {
    width:calc(35% - 25px);
    margin-left: 25px;
}
.file-upload-box {
    background: #eef6f9;
    width: 100%;
    border-radius: 10px;
    border: 2px dashed #ddd;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-height: 200px;
    cursor: pointer;
    flex-direction: column;
}
.file-upload-box > span {
    display: block;
    width: 100%;
    font-weight: 600;
    margin-top:10px;
}
.file-upload-box > span span {
   color: #1f85cd;
   border-bottom:1px solid;
}
.right-section .right-form .upload-img .img-box {
    margin-bottom: 20px;
    text-align: center;
}
</style>

